const ShowInTable = [
    // {
    //   name: "IDN",
    //   key: "IDN",
    //   short: true
    // },
    // {
    //   name: "CRC",
    //   key: "CRC",
    //   short: false
    // },
    {
      name: "Serial number",
      key: "SNUM",
      short: true
    },
    {
      name: "Type",
      key: "TYPE",
      short: true
    },
    {
      name: "LP Count",
      key: "LPCOUNT",
      short: true
    },
    {
      name: "Time",
      key: "MTIME",
      short: true
    },
    {
      name: "Manufacturer",
      key: "PRODUCER",
      short: true
    },
    {
      name: "Year",
      key: "YMAN",
      short: true
    },
    {
      name: "Voltage ratings",
      key: "VOLTAGE"
    },
    {
      name: "Current ratings",
      key: "CURRENT"
    },
    {
      name: "Constant",
      key: "CONSTANT"
    },
    {
      name: "Constant unit",
      key: "CONSTUNIT"
    },
    {
      name: "Scalefactor",
      key: "SCALEFACTOR"
    },
    {
      name: "Accuracy class",
      key: "CLASS",
      short: true
    },
    {
      name: "Energy type",
      key: "MENERGYTYPE"
    },
    {
      name: "Frequency",
      key: "FREQ"
    },
    {
      name: "Connection type",
      key: "CONTYPE"
    },
    {
      name: "Customer",
      key: "CUSTOMER",
      short: true
    },
    {
      name: "Area",
      key: "AREA"
    },
    {
      name: "Location",
      key: "LOCATION",
      short: true
    },
    {
      name: "Address",
      key: "ADDRESS",
      short: true
    },
    {
      name: "CT Ratio",
      key: "CTRATIO"
    },
    {
      name: "VT Ratio",
      key: "VTRATIO"
    },
    {
      name: "Note 1",
      key: "NOTE1"
    },
    {
      name: "Note 2",
      key: "NOTE2"
    },
    {
      name: "Note 3",
      key: "NOTE3"
    },
    {
      name: "Note 4",
      key: "NOTE4"
    },
    {
      name: "Measurement type",
      key: "ELM_OUTPUT_TYPE"
    },
    {
      name: "IMIN",
      key: "IMIN"
    },
    {
      name: "INOM",
      key: "INOM"
    },
    {
      name: "IMAX",
      key: "IMAX"
    },
    {
      name: "UNOM",
      key: "UNOM"
    },
    {
      name: "SQRT3",
      key: "SQRT3"
    },
    {
      name: "Constant type",
      key: "CONSTTYPE"
    },
    {
      name: "ISIDE",
      key: "ISIDE"
    },
    {
      name: "USIDE",
      key: "USIDE"
    },
    {
      name: "DIALREG",
      key: "DIALREG"
    },
    {
      name: "Energy method",
      key: "ENERMETHOD"
    },
    {
      name: "CT Snom",
      key: "CTSNOM"
    },
    {
      name: "VT Snom",
      key: "VTSNOM"
    }
  ];


export {
    ShowInTable
}